import React from 'react'

const DebugInfoContext = React.createContext();

export default DebugInfoContext;